<div class="flex-col-container justify-between">
  <div [ngClass]="description === undefined ? 'items-center' : 'items-start'" class="flex-row-container justify-between gap-8">
    <img *ngIf="data?.icon && isSvg" src="../../../../../../assets/svg/{{getIcon}}.svg" alt="snack-icon" />
    <mat-icon [ngStyle]="{'color': getColor(class)}" *ngIf="!isSvg">{{getIcon}}</mat-icon>
    <div class="detail-container">
      <div [innerHTML]="data.message" [ngClass]="{'fw-500': description !== undefined}"></div>
      <div [innerHTML]="description" *ngIf="description !== undefined"></div>
      <div class="flex-row-container items-end justify-end" *ngIf="data?.hasLongButton || data?.hasCopyButton">
        <button mat-button *ngIf="data?.hasLongButton" (click)="onActionButton()">{{data?.textLongButton}}</button>
        <div *ngIf="data?.hasCopyButton">
          <button mat-mini-fab [cdkCopyToClipboard]="description">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <button mat-icon-button *ngIf="!data?.hasAction" (click)="close()">
      <mat-icon [ngClass]="{'v-top': description !== undefined}">close</mat-icon>
    </button>
    <button mat-button *ngIf="data?.hasAction" (click)="onActionButton()">{{data?.textAction}}</button>
  </div>
</div>
